@if (initialized) {
  @if (!issues.length) {
    <div class="mat-body-strong">No issues</div>
  }
  @if (issues.length) {
    <!-- Open issues -->
    @if (open.length) {
      <section>
        <div class="mat-body-2">Open</div>
        <div class="list-items">
          @for (issue of open; track issue) {
            <app-issue-card
              [project]="project"
              [issue]="issue" class="stroked-card link"
              (click)="onClick(issue)">
            </app-issue-card>
          }
        </div>
      </section>
    }
    <!-- /Open issues -->
    <!-- closed today issues -->
    @if (closedToday.length) {
      <section>
        <div class="mat-body-2">Closed today</div>
        <div class="list-items">
          @for (issue of closedToday; track issue) {
            <app-issue-card
              [project]="project"
              [issue]="issue"
              class="stroked-card link" [status]="false"
            (click)="onClick(issue)"></app-issue-card>
          }
        </div>
      </section>
    }
    <!-- /closed today issues -->
    <section>
      <a class="no-style link mat-body-2" [routerLink]="['/projects', project.id]"
        [queryParams]="{ tab: 'issues', scope: site.id }">
        View all
      </a>
    </section>
  }
}
